import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '@app/services/local-storage.service';
import { NavigationService } from '@app/services/navigation.service';
import { SiteService } from '@app/services/site.service';
import { UserAccountService } from 'app-classic/services/user-account.service';
import { ErrorComponent as NewErrorComponent } from '../../../app/components/error/error.component';

export enum WarningScreenType {
    InvalidUrlScreen,
    ErrorScreen,
    IncorrectTimeScreen,
}

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false,
})
export class ErrorComponent extends NewErrorComponent implements OnInit {
    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _localStorageService: LocalStorageService,
        private navigationService: NavigationService,
        private _userAccountService: UserAccountService,
        private _siteService: SiteService
    ) {
        super(_router, _route, _localStorageService, _userAccountService, _siteService);
    }

    @HostBinding('class.error-container')
    ngOnInit() {
        super.ngOnInit();
        this.navigationService.setIsLoading(false);
    }
}
